<script>
import {
  CdrImg,
  CdrButton,
  IconCheckStroke,
} from '@rei/cedar';

export default {
  name: 'ButtonImgComponent',
  components: {
    CdrImg,
    CdrButton,
    IconCheckStroke,
  },
  props: {
    mediaCode: {
      type: String,
      required: true,
    },
    mediaPath: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  emits: ['selectCard'],
  methods: {
    onGiftCard() {
      this.$emit('selectCard', {
        mediaCode: this.mediaCode,
        mediaPath: this.mediaPath,
        description: this.description,
        selected: this.selected,
        index: this.index + 1,
      });
    },
  },
};
</script>

<template>
  <cdr-button
    :key="mediaCode"
    class="card__button"
    :icon-only="true"
    :data-ui="`mediacode-${mediaCode}`"
    :aria-checked="selected"
    :aria-label="description"
    :data-media-code="mediaCode"
    role="radio"
    @click="onGiftCard"
  >
    <template #icon>
      <cdr-img
        class="card__image"
        :src="mediaPath"
        :alt="description"
        :loading="index > 5 ? 'lazy' : 'eager'"
        radius="rounded"
      />
      <div
        v-if="selected"
        class="card__overlay"
      />
      <icon-check-stroke
        v-if="selected"
        class="card__icon"
      />
    </template>
  </cdr-button>
</template>
